import { ApiError } from '../api/client.js';

import { EmptyState } from './EmptyState.js';

/** What a page shows when its main query failed. */
export function PageError({ error }: { error: unknown }) {
  const message =
    error instanceof ApiError ? error.message : 'Baseline couldn’t reach the server. Try again.';
  return (
    <div className="pg">
      <EmptyState title="This page didn’t load." sub={message} />
    </div>
  );
}
